import { useSelector } from 'react-redux';

export const cleanTrackName = (title) => {
	let cleaned = title.replace('.mp3','');
    cleaned = cleaned.replace('.wav','');
    return cleaned;
}

export const cleanStemName = (title, parentTitle) => {
	let cleaned = title.replace('.mp3','');
    cleaned = cleaned.replace('.wav','');
    cleaned = cleaned.replace('_Stem_','');
    cleaned = cleaned.replace(parentTitle,'');
    return cleaned;
}

export const playDelay = 10;

export const getNextTrackIndex = (track, playlist) => {
    let playlistTrack = playlist.find((t) => t.id === track.id);
    let idx = playlist.indexOf(playlistTrack);
    if (idx === playlist.length - 1 ) {
        idx = 0;
    } else {
        idx += 1;
    }
    return idx;
}

export const getPreviousTrackIndex = (track,playlist) => {
    let playlistTrack = playlist.find((t) => t.id === track.id);
    let idx = playlist.indexOf(playlistTrack);
    if (idx - 1 < 0 ) {
        idx = playlist.length -1;
    } else {
        idx -= 1;
    }
    return idx;
}

export const IsCurrentTrack = (track) => {
    const trackInfo = useSelector(state => state.audioPlayer.currentTrack)
    return track === trackInfo;
}

export const  timeout = (delay) => {
    return new Promise( res => setTimeout(res, delay) );
}

export const durationToSeconds = (duration) => {
    return duration.split(':')
        .reverse()
        .reduce((total, part, index) => total + parseInt(part, 10) * Math.pow(60, index), 0);
}

/* utils.durationRanges
    '0 - 30s',
    '30s - 1min',
    '1min - 2min',
    '2min +'
*/
//TODO: return ranges below based on constants
export const durationToDurationRange = (duration) => {
    const trackDurationInSeconds = durationToSeconds(duration);
    if (trackDurationInSeconds <= 30) {
        return '0 - 30s';
    } else if (trackDurationInSeconds <= 60) {
        return '30s - 1min';
    } else if (trackDurationInSeconds <= 120) {
        return '1min - 2min';
    } else {
        return '2min +'
    } 
}

/*
    'Slow',
    'Medium',
    'Fast'
*/
//TODO: return ranges below based on constants
export const bpmToTempoRange = (bpm) => {
    if (bpm <= 70) {
        return 'Slow';
    } else if (71 <= bpm <= 100) {
        return 'Medium';
    } else {
        return 'Fast'
    } 
}

export const getServerEndpoint = () => {
    if (process.env.NODE_ENV === 'development') {
        return 'http://localhost:4000/api'; //development
    } else {
        return '/api'; //production
    }
}